export default {
    props: {
        modelValue: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            externalUrl: ""
        };
    },
    watch: {
        modelValue: {
            handler (newVal) {
                this.externalUrl = newVal;
            },
            immediate: true,
            deep: true
        },
        externalUrl (val) {
            this.$emit('update:modelValue', val);
        }
    },
    methods: {
        onChange () {
        // 触发更新
        }
    }
};
